import axios from "axios";
import { FIREBASE_API } from "./config";

export default () => {
  axios.defaults.baseURL = FIREBASE_API.baseApiHostPath;
};
